// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c254a8fd","31":"9cffe6f1","390":"18d23fc1","896":"f26e1472"}[chunkId] + ".chunk.js";
};